import React, { useEffect, useState, useContext, useRef } from "react";
// import "../../src/assets/style/Job.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toastMsg } from "../component/toast";
import send from "../../src/assets/images/send1.png";
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from "react-to-print";
import { updateFormField, setFormData, resetFormData, setStep, setHeaderText, setSelectedKeywords } from './Slices/formSlice';
import { updateJdResponsesArray, setJdResponsesArray } from './Slices/jdResponsesSlices'
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import Spinner from "react-bootstrap/Spinner";
import GeneratedSkills from "./JobDescriptionScreens/GeneratedSkills";
import { BehaviourQuestions } from "./JobDescriptionScreens/BehaviourQuestions";
import Behaviors from "./Behaviors";
import { formatJobDetails } from "./JobDescriptionScreens/JobDescriptionsMethods";
// import "../../src/assets/style/Dummy.css";
import { ApiConfig, BASE_URL } from "../Api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { PostCallWithErrorResponse, fetchPOST, multipartPostCall, multipartPostCallWithErrorResponse, putMultipartWithAuthCallWithErrorResponseNodeCreate, simpleDeleteCall, simpleGetCall, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import TotalMarketing from "./TotalMarketing";
import AddQuestion from "./JobDescriptionScreens/AssesmentScreens/AddQuestion";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import AddCompany from "./AddCompany";
import { jobType, lungueges, travelRequirement, workType } from "../constant/jobType";
import CustomSelect from "../constant/customselect";
import CustomButton from "../component/button";
import KeywordSkeleton from "../component/skeletons/keywordSkeleton";
import BehaviourQuestionSkeleton from "../component/skeletons/BehaviourQuestionSkeleton";
import InputSkeleton from "../component/skeletons/InputSkeleton";
import { arraysEqual, parseQuestions } from "../common";
import JobDatas from "./JobDatas";
import FileSaver from "file-saver";
import MessageBox from "../component/MessageBox";


export default function JobDescription() {
  const navigate = useNavigate();
  // const [step, setStep] = useState(1);
  const step = useSelector((state) => state.form.step);
  const headerText = useSelector((state) => state.form.headerText);
  const [quizes, setQuizes] = useState([])
  const { adminData } = useContext(AppContext)
  const [result, setResult] = useState('')
  const { openSideBar, setOpenSideBar, activeMenu, setActiveMenu } =
    useContext(AppContext);
  const [error, setError] = useState(""); // Error state

  const [regenrateJd, setIsReenerateJd] = useState(false)

  const [isKeyWordChange, setIsKeywordChange] = useState(false)


  const formData = useSelector((state) => state.form);
  const jdResponsesArrays = useSelector((state) => state.jdResponses);
  const [companyData, setCompanyData] = useState('');

  const [isAbleToPublish, setIsAbleToPublish] = useState(false)
  console.log('formData-->', formData)
  const dispatch = useDispatch();

  const [customKeyword, setCustomKeyword] = useState('');
  const [customKeywords, setCustomKeywords] = useState([]);

  const [loadingForRegenerateSkills, setLoadingForRegenerateSkills] =
    useState(false);
  const [isDownloading, setISDownloading] = useState(false)
  const [isDownloadingWord, setIsDownloadingWord] = useState(false)

  const [generatedJobDescription, setGeneratedJobDescription] = useState("");
  // const [identifiedBehaviour, setIdentifiedBehaviour] = useState([]);
  const [generatedJobDetails, setGeneratedJobDetails] = useState([]);

  const [loadingForGenerateKeyword, setLoadingForGenerateKeyword] =
    useState(false);
  const [loadingForGettingBehaviour, setLoadingForGettingBehaviour] =
    useState(false);
  const [loadingForBehaviourQuestions, setLoadingForBehaviourQuestions] =
    useState(false);
  const [generateKeywordsApiSuccess, setGenerateKeywordsApiSuccess] =
    useState(false);
  const [loadingForGenerateSkills, setLoadingForGenerateSkills] =
    useState(false);
  const [loadingForGeneratedCustomQuestions, setLoadingForGeneratedCustomQuestions] =
    useState(false);
  const [loadingForRegeneratedKeywords, setLoadingForRegeneratedKeywords] =
    useState(false);
  const [loadingForRegeneratedJobDetails, setLoadingForRegeneratedJobDetails] =
    useState(false);
  const [loadingForPublishJD, setLoadingForPublishJD] =
    useState(false);
  const [
    loadingForGenerateJobDescription,
    setLoadingForGenerateJobDescription,
  ] = useState(false);
  const [
    loadingForRegenerateJobDescription,
    setLoadingForRegenerateJobDescription,
  ] = useState(false);
  const [
    loadingForRegenerateJobResponsibilities,
    setLoadingForRegenerateJobResponsibilities,
  ] = useState(false);
  const [loadingForRegenerateJobDetails, setLoadingForRegenerateJobDetails] =
    useState(false);
  const [loadingForGenerateJobDetails, setLoadingForGenerateJobDetails] =
    useState(false);
  const handleChange = (e) => {
    // setFormData({ ...formData, [e.target.name]: e.target.value });
    dispatch(updateFormField({ field: e.target.name, value: e.target.value }));
  };

  const handleOptionChange = (
    questionIndex,
    // selectedBehaviorCode,
    questions,
    option
  ) => {

    const updatedAnswers = [...formData.answers]; // formData is your redux state slice
    updatedAnswers[questionIndex] = {
      q: questions,
      // behavior_code: selectedBehaviorCode,
      // behavior_code: questionIndex,
      option: option,
    };

    dispatch(updateFormField({ field: 'answers', value: updatedAnswers }));
  };




  async function generateKeywords() {
    setLoadingForGenerateKeyword(true);
    dispatch(updateFormField({ field: 'selectedKeywords', value: [] }));
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
    };

    console.log(payload);


    try {
      const response = await fetchPOST(
        ApiConfig.POST_GENERATE_KEYWORDS,
        payload
      );

      if (response.status === 200) {
        setGenerateKeywordsApiSuccess(true);
        // setAllKeywords(response.keywords.keywords);
        dispatch(updateFormField({ field: 'selectedKeywords', value: response.data.recommended_keywords }));
        dispatch(updateFormField({ field: 'allKeywords', value: response.keywords.keywords }));
        dispatch(updateFormField({ field: 'generatedKeywordApiResponse', value: response }));
        dispatch(updateFormField({ field: 'filteranalysis', value: response?.filtered_analysis }))
      }
    } catch (err) {
      sessionStorage.setItem(COMPANY_STORAGE_KEY, {})
      sessionStorage.setItem(JOBDETAILS_STORAGE_KEY, {})
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
      setGenerateKeywordsApiSuccess(false);
    } finally {
      setLoadingForGenerateKeyword(false);

    }
  }






  async function generateBehaviourQuestions() {
    // setIdentifiedBehaviour([]);
    dispatch(updateFormField({ field: 'answers', value: [] }));
    dispatch(updateFormField({ field: 'identifiedBehaviour', value: [] }));
    setLoadingForBehaviourQuestions(true);
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      filtered_analysis: formData?.filteranalysis
    };

    try {
      const response = await fetchPOST(
        ApiConfig.POST_GENERATE_BEHAVIOUR_QUESTIONS,
        payload
      );

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'behaviourQuestionsArray', value: response.behavior_questions.questions || [] }));
      }
    } catch (err) {
      sessionStorage.setItem(KEYWORDS_STORAGE_KEY, [])
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForBehaviourQuestions(false);
    }
  }
  async function handleGenerateBehaviour() {

    const allAnswered = formData.answers.every(
      (answer) => answer && typeof answer === 'object' && answer.option
    );
    const hasEmptyOrNull = formData.answers.some(
      item => item === null || item === undefined || item === ''
    );

    if (hasEmptyOrNull) {

      setError("Please answer all the questions");
      return;
    }
    // if (formData.answers.length !== formData.behaviourQuestionsArray.length) {

    //   setError("Please answer all the questions");
    //   return;
    // }

    setError("");
    setLoadingForGettingBehaviour(true);
    setLoadingForGenerateSkills(true)
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      answers: formData.answers,
      filtered_analysis: formData?.filteranalysis
    };
    setLoadingForGenerateJobDescription(true);
    setLoadingForGeneratedCustomQuestions(true);
    // setGenerateBehaviourCompleteFlag(false)
    dispatch(updateFormField({ field: 'generateBehaviourCompleteFlag', value: false }));
    try {
      // const response = await fetchPOST(
      //   ApiConfig.POST_GENERATE_BEHAVIOUR,
      //   payload
      // );

      // if (response.status === 200) {
      // setIdentifiedBehaviour(response.behaviours);

      // dispatch(updateFormField({ field: 'identifiedBehaviour', value: response }));
      // sessionStorage.setItem(BEHAVIORS_STORAGE_KEY, JSON.stringify(response?.behaviours));
      await generateTempJobCodeAPI([])
      // setGenerateBehaviourCompleteFlag(true)
      dispatch(updateFormField({ field: 'generateBehaviourCompleteFlag', value: true }));
      functionToTriggerSkillGeneration()

      // }
    } catch (err) {
      // setGenerateBehaviourCompleteFlag(false)
      dispatch(updateFormField({ field: 'generateBehaviourCompleteFlag', value: false }));
      sessionStorage.setItem(ANSWERS_STORAGE_KEY, [])
      console.error("Error submitting form:", err.message);
      if (err?.detail?.[0]?.msg === 'Input should be a valid dictionary or object to extract fields from') {
        toastMsg("error", 'Please select all questions');
      } else {
        toastMsg("error", `${err?.message} Please answered all questions and try again`);
      }
    } finally {


      setLoadingForGettingBehaviour(false);
    }
  }


  function getRecommendedSkills(skillGroups) {
    if (!Array.isArray(skillGroups)) {
      throw new TypeError("Input must be an array.");
    }

    return skillGroups.flatMap(group =>
      Array.isArray(group.recommended_skills) ? group.recommended_skills : []
    );
  }

  const extractBehaviorTitles = (array) => {
    return array?.map(item => item?.title)
  }
  async function generateSkills() {
    setLoadingForGenerateSkills(true);
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || [],
      filtered_analysis: formData?.filteranalysis
    };

    try {
      const response = await fetchPOST(ApiConfig.POST_GENERATE_SKILLS, payload);

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'generatedSkillsArray', value: response.skill_groups }));
        dispatch(updateFormField({ field: 'finalSkillsArray', value: response.skill_groups }));
        const temp = response?.skill_groups?.map((i) => {
          return {
            group_name: i?.group_name,
            recommended_skills: i?.recommended_skills?.length > 8 ? i?.recommended_skills?.slice(0, 8) : i?.recommended_skills
          }
        })

        console.log(response, temp, 'temp');

        dispatch(updateFormField({ field: 'skillsRequiredForJob', value: temp }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForGenerateSkills(false);
    }
  }

  const controller = new AbortController();

  async function getBehaviorQuestions() {

    if (loadingForBehaviourQuestions) return

    setLoadingForBehaviourQuestions(true);

    setResult('')

    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      filtered_analysis: formData?.filteranalysis
    };

    const res = await fetch(
      "https://lywo-genai.azurewebsites.net/jd_creation/generate_behavior_questions",
      {
        signal: controller.signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    // const res = await PostCallWithErrorResponse(ApiConfig.GENERATE_BEHAVIOUR_QUESTION, payload)
    if (!res.ok) throw new Error("Network response was not ok");
    console.log(JSON.stringify(res));
    if (res.body) {
      console.log("Streaming response started...");
      // Create a reader to read the stream
      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let result = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        console.log("Raw chunk:", chunk);

        // Split by newlines in case multiple messages are in one chunk
        const lines = chunk.split("\n");
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            const jsonStr = line.replace("data: ", "").trim();
            if (jsonStr === "[DONE]") {
              console.log("Stream complete.");
              break;
            }

            try {
              const parsed = JSON.parse(jsonStr);
              console.log("Parsed stream data:", parsed);

              // You can now do whatever you want with parsed.content
              if (parsed.content) {
                result += parsed.content;
                setResult(prev => prev + parsed.content)
                // container.innerHTML = marked.parse(result);; // Update UI
              }
            } catch (err) {
              console.warn("Skipping invalid JSON line:", jsonStr);
            }
          }
        }
      }

      console.log("Final streamed result:", parseQuestions(result));
      dispatch(updateFormField({ field: 'behaviourQuestionsArray', value: parseQuestions(result) }))

      setLoadingForBehaviourQuestions(false);
    }
  }


  async function generateCustomQuestionsAPI() {

    setLoadingForGeneratedCustomQuestions(true);
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      filtered_analysis: formData?.filteranalysis || 'string',
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []

    };

    try {
      const response = await fetchPOST(ApiConfig.POST_GENERATE_CUSTOM_QUESTIONS, payload);

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'generatedCustomQuestions', value: response }));
        dispatch(updateFormField({ field: 'generatedKeywordsForUser', value: response?.data?.keywords }));
        dispatch(updateFormField({ field: 'finalKeywordsForUser', value: response?.data?.keywords }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForGeneratedCustomQuestions(false);
    }
  }

  async function regenerateKeywordsForUserAPI() {

    setLoadingForRegeneratedKeywords(true);
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      // filtered_analysis : formData.generatedKeywordApiResponse?.filtered_analysis || 'string',
      original_section: formData.finalKeywordsForUser,
      feedback: formData.feedbackForKeyWordsRegeneration,
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []

    };

    try {
      const response = await fetchPOST(ApiConfig.POST_REGENERATE_KEYWORDS_FOR_USERS, payload);

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'regeneratedKeywordsForUser', value: response.keywords_for_user.keywords }));
        dispatch(updateFormField({ field: 'finalKeywordsForUser', value: response.keywords_for_user.keywords }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForRegeneratedKeywords(false);
    }
  }

  async function regenerateJobDetailsAPI() {

    setLoadingForRegeneratedJobDetails(true);
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      // filtered_analysis : formData.generatedKeywordApiResponse?.filtered_analysis || 'string',
      original_section: formData.jobDetailsRespArray,
      feedback: formData.feedbackForJonDetailsRegeneration,
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []

    };

    try {
      const response = await fetchPOST(ApiConfig.POST_REGENERATE_JOB_DETAILS_FOR_USERS, payload);

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'regeneratedJobDetailsArray', value: response.job_details }));
        dispatch(updateFormField({ field: 'finalJobDetails', value: response.job_details }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForRegeneratedJobDetails(false);
    }
  }



  const getCompanyDetails = async (id) => {
    if (!id) return;

    try {
      const res = await simpleGetCallWithErrorResponse(ApiConfig.GET_COMPANY_DETAIL + id);

      if (res?.json?.succeded) {
        const data = res?.json?.response;
        setCompanyData(data);

      } else {

      }
    } catch (error) {
      console.error("Error fetching company details:", error);

    }
  };
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  useEffect(() => {
    if (step === 3) {
      getCompanyDetails(formData?.companyId)
    }
  }, [step])
  async function regenerateSkillsAPI() {
    //taleeb
    setLoadingForRegenerateSkills(true);
    // await 
    // await sleep(3000)


    console.log('companyData?.companyQA--', companyData?.companyQA, (Array.isArray(companyData?.companyQA)))
    const companyQA = companyData ? JSON.parse(companyData?.companyQA) : '';
    const companyQuestions = Array.isArray(companyQA) && companyQA?.length > 0
      ? companyQA?.map(item => ({
        question: item?.Question ?? "",
        answer: item?.Answer ?? ""
      }))
      : [
        {
          question: "string",
          answer: "string"
        }
      ];
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,

        company_questions: companyQuestions
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      // filtered_analysis : formData.generatedKeywordApiResponse?.filtered_analysis || 'string',
      original_section: formData.generatedSkillsArray,
      feedback: formData.feedbackForSkillRegeneration,
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []

    };

    try {
      const response = await fetchPOST(ApiConfig.REGENERATE_SKILL, payload);

      if (response.status === 200) {

        dispatch(updateFormField({ field: 'reGeneratedSkillsArray', value: response.skill_groups.skill_groups }));
        dispatch(updateFormField({ field: 'finalSkillsArray', value: response.skill_groups.skill_groups }));
        dispatch(updateFormField({ field: 'feedbackForSkillRegeneration', value: '' }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForRegenerateSkills(false);
    }
  }




  async function generateJobDescriptionAPI(regenerate) {

    if (regenerate) {
      setLoadingForRegenerateJobDescription(true);
    } else {
      setLoadingForGenerateJobDescription(true);
    }
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []
    };
    if (regenerate) {
      payload.original_section = formData.finalSelectedJobDescription;
      payload.feedback = formData.feedbackForJobDescription;
    }
    const api = regenerate
      ? ApiConfig.POST_REGENERATE_JOB_DESCRIPTION
      : ApiConfig.POST_GENERATE_JOB_DESCRIPTION;
    try {
      const response = await fetchPOST(api, payload);

      if (response.status === 200) {
        // setGeneratedJobDescription(response.job_description);
        if (regenerate) {
          dispatch(updateFormField({ field: 'RegeneratedJobDescription', value: response.job_description }));
          dispatch(updateFormField({ field: 'finalSelectedJobDescription', value: response.job_description }));
        } else {
          dispatch(updateFormField({ field: 'generatedJobDescription', value: response.job_description }));
          dispatch(updateFormField({ field: 'generatedResponsibilities', value: response.job_data.job_responsibilities }));


          dispatch(updateFormField({ field: 'finalSelectedResponsibilities', value: response.job_data.job_responsibilities }));
          dispatch(updateFormField({ field: 'jobDetailsRespArray', value: response.job_data.job_details }));
          dispatch(updateFormField({ field: 'finalJobDetails', value: response.job_data.job_details }));
          dispatch(updateFormField({ field: 'finalSelectedJobDescription', value: response.job_description }));
          // dispatch(updateFormField({ field: 'skillsRequiredForJob', value: response.job_data.skill_groups }));

        }
      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForGenerateJobDescription(false);
      setLoadingForRegenerateJobDescription(false);
    }
  }


  async function generateJobResponsibilitiesAPI(regenerate) {
    //
    setLoadingForRegenerateJobResponsibilities(true);

    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []
    };
    if (regenerate) {
      payload.original_section = formData.generatedResponsibilities;
      payload.feedback = formData.feedbackForJobResponsibilities;
    }
    const api = ApiConfig.POST_REGENERATE_JOB_RESPONSIBILITIES
    try {
      const response = await fetchPOST(api, payload);

      if (response.status === 200) {
        // setGeneratedJobDescription(response.job_description);


        dispatch(updateFormField({ field: 'regeneratedResponsibilities', value: response.job_responsibilities.job_responsibilities }));
        dispatch(updateFormField({ field: 'finalSelectedResponsibilities', value: response.job_responsibilities.job_responsibilities }));

      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForRegenerateJobResponsibilities(false);

    }
  }
  async function generateJobDetailsAPI(regenerate) {
    if (regenerate) {
      setLoadingForRegenerateJobDetails(true);
    } else {
      setLoadingForGenerateJobDetails(true);
    }
    const payload = {
      company_details: {
        company_name: formData.companyName,
        industry: formData.industry,
        company_size: formData.companySize,
        location: formData.location,
        company_type: formData.companyType,
        company_description: formData.companyDescription,
        company_website: formData.website,
      },
      job_details: {
        job_title: formData.jobTitle,
        no_of_positions: formData.noOfPositions,
        job_department: formData.department,
        job_location: formData.locationJobDetails,
        job_language: formData.anyLanguageOtherThanEnglish,
        job_type: formData.jobType,
        workplace_type: formData.workPlaceType,
        job_description: formData.descriptionAboutJob,
        experience_required: formData.experience,
        salary_range: formData.salary,
        job_qualifications: formData.minEducationQualification,
        travel_requirements: formData.travelRequirement,
      },
      selected_keywords: formData.selectedKeywords,
      // behaviors: formData.identifiedBehaviour.behaviours || [],
      behaviors: extractBehaviorTitles(formData?.behaviorsDataApi?.selectedByUser) || []
    };
    if (regenerate) {
      payload.original_section = generatedJobDescription;
      payload.feedback = formData.feedbackForJobDescription;
    }
    const api = regenerate
      ? ApiConfig.POST_REGENERATE_JOB_DETAILS
      : ApiConfig.POST_GENERATE_JOB_DETAILS;
    try {
      const response = await fetchPOST(api, payload);

      if (response.status === 200) {
        const JobD = formatJobDetails(response.job_details);
        setGeneratedJobDetails(JobD);
      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForGenerateJobDetails(false);
      setLoadingForRegenerateJobDetails(false);
    }
  }

  const nextStep = async () => {



    if (step === 1 && formData.selectedKeywords.length === 0) {
      setError("Please select at least one keyword");
      return;
    }

    if (step === 2) {
      const allAnswered = formData.answers.every(
        (answer) => answer && typeof answer === 'object' && answer.option
      );

      if (!allAnswered) {
        setError("Please answer all the questions");
        return;
      }
      if (formData.answers.length !== formData.behaviourQuestionsArray.length) {
        setError("Please answer all the questions");
        return;
      }
      if (formData?.identifiedBehaviour?.behaviours?.length < 1) {
        setError("Please Generate Behaviour First");
        return;
      }

      // await generateTempJobCodeAPI()
    }


    if (step === 4 && !formData.responsibilities.trim()) {
      setError("Please enter the primary responsibilities");
      return;
    }


    setError("");
    if (step < 4) {
      dispatch(setStep(step + 1));
    }
  };

  useEffect(() => {
    return () => {
      controller.abort();

    };
  }, [])

  useEffect(() => {

    return () => {
      setGenerateKeywordsApiSuccess(false)
    }
  }, [generateKeywordsApiSuccess]);

  useEffect(() => {

    if (step == 1) {
      functionToTriggerKeywordGeneration()
    }
  }, [step]);


  useEffect(() => {

    if (step === 3 && formData.generateBehaviourCompleteFlag) {


      if (formData?.isTryToChangeBehaviour) {

        if (arraysEqual(formData?.behaviorsDataApi?.selected, formData?.behaviorsDataApi?.selectedByUser)) return


      }

      generateJobDescriptionAPI(false)

      generateCustomQuestionsAPI()
      dispatch(updateFormField({ field: 'generateBehaviourCompleteFlag', value: false }));
    }
  }, [step, formData.generateBehaviourCompleteFlag, formData?.behaviorsDataApi?.selectedByUser])
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const KEYWORDS_STORAGE_KEY = 'prev_selected_keywords';
  const ANSWERS_STORAGE_KEY = 'prev_selected_answers';
  const BEHAVIORS_STORAGE_KEY = 'prev_selected_behaviors';
  const COMPANY_STORAGE_KEY = 'prev_selected_company';
  const JOBDETAILS_STORAGE_KEY = 'prev_selected_jobdetails';

  function arraysAreEqual(arr1 = [], arr2 = []) {
    console.log("arr1--", arr1)
    console.log("arr2--", arr2)
    if (arr1.length !== arr2.length) return false;
    return arr1.every((val, i) => val === arr2[i]);
  }
  function arraysAreEqual2(arr1 = [], arr2 = []) {
    if (arr1.length !== arr2.length) return false;
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }
  function objectsAreDifferent(obj1 = {}, obj2 = {}) {
    const normalize = (obj) =>
      JSON.stringify(
        Object.keys(obj).sort().reduce((acc, key) => {
          acc[key] = obj[key];
          return acc;
        }, {})
      );

    return normalize(obj1) !== normalize(obj2);
  }

  const company_details = {
    company_name: formData.companyName,
    industry: formData.industry,
    company_size: formData.companySize,
    location: formData.location,
    company_type: formData.companyType,
    company_description: formData.companyDescription,
    company_website: formData.website,
  };
  const job_details = {
    job_title: formData.jobTitle,
    no_of_positions: formData.noOfPositions,
    job_department: formData.department,
    job_location: formData.locationJobDetails,
    job_language: formData.anyLanguageOtherThanEnglish,
    job_type: formData.jobType,
    workplace_type: formData.workPlaceType,
    job_description: formData.descriptionAboutJob,
    experience_required: formData.experience,
    salary_range: formData.salary,
    job_qualifications: formData.minEducationQualification,
    travel_requirements: formData.travelRequirement,
  }


  const [searchParams] = useSearchParams()



  const functionToTriggerKeywordGeneration = async () => {

    let isBack = searchParams.get('isBack')

    if (!isBack) {
      if (formData?.isEdit && formData?.allKeywords?.length !== 0) return
    }




    const stored = sessionStorage.getItem(COMPANY_STORAGE_KEY);
    const stored2 = sessionStorage.getItem(JOBDETAILS_STORAGE_KEY);
    const prevCompanyDetails = stored ? JSON.parse(stored) : [];
    const prevJobDetails = stored2 ? JSON.parse(stored2) : [];

    const hasChangedCompany = objectsAreDifferent(company_details, prevCompanyDetails);
    const hasChangedjob = objectsAreDifferent(job_details, prevJobDetails);

    if (hasChangedCompany || hasChangedjob || formData?.allKeywords?.length == 0) {

      if (isBack) {
        dispatch(updateFormField({ field: 'selectedKeywords', value: [] }));
        setIsReenerateJd(false)
      }

      setIsReenerateJd(false)

      await generateKeywords();
      sessionStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(company_details));
      sessionStorage.setItem(JOBDETAILS_STORAGE_KEY, JSON.stringify(job_details));
    } else if (isBack) {
      setIsReenerateJd(true)
    } /* else {
      dispatch(updateFormField({ field: 'step', value: 2 }));
    } */
  }


  const functionToTriggerBehaviourGeneration = async () => {



    // nextStep()
    const stored = sessionStorage.getItem(ANSWERS_STORAGE_KEY);
    const prevAnswers = stored ? JSON.parse(stored) : [];

    const hasChanged = !arraysAreEqual2(formData.answers, prevAnswers);

    const stored2 = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);

    const prevBehaviors = stored ? parseJSONSafe(stored) : [];
    const prevKeywords = stored2 ? parseJSONSafe(stored2) : [];


    if (!arraysAreEqual(prevKeywords, formData?.selectedKeywords) || !formData?.finalSelectedJobDescription) {


      handleGenerateBehaviour();
      sessionStorage.setItem(ANSWERS_STORAGE_KEY, JSON.stringify(formData.answers));
    }


  }
  console.log('test pushing')

  const parseJSONSafe = (value) => {
    try {
      if (value === null || value === "undefined") return undefined;
      return JSON.parse(value);
    } catch {
      return undefined;
    }
  };
  const functionToTriggerSkillGeneration = async () => {

    const stored = sessionStorage.getItem(BEHAVIORS_STORAGE_KEY);
    const stored2 = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);

    const prevBehaviors = stored ? parseJSONSafe(stored) : [];
    const prevKeywords = stored2 ? parseJSONSafe(stored2) : [];



    if (!arraysAreEqual(prevKeywords, formData.selectedKeywords)) {

      await generateSkills();
      console.log(formData);
      sessionStorage.setItem(BEHAVIORS_STORAGE_KEY, JSON.stringify(formData.identifiedBehaviour.behaviours));
      sessionStorage.setItem(KEYWORDS_STORAGE_KEY, JSON.stringify(formData.selectedKeywords));
    }
  }
  const useBehaviourQuestionTrigger = (step, selectedKeywords, generateBehaviourQuestions) => {
    useEffect(() => {

      if (step !== 2 || !Array.isArray(selectedKeywords)) return;

      const stored = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);
      const prevKeywords = stored ? JSON?.parse(stored || '') : [];

      const hasChanged = !arraysAreEqual(selectedKeywords, prevKeywords);



      if (hasChanged || formData?.behaviourQuestionsArray?.length === 0) {

        getBehaviorQuestions()
        sessionStorage.setItem(KEYWORDS_STORAGE_KEY, JSON.stringify(selectedKeywords));
      }

      // else: do nothing if keywords are the same

    }, [step, selectedKeywords, generateBehaviourQuestions]);
  };

  useBehaviourQuestionTrigger(formData.step, formData.selectedKeywords)


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



  const prevStep = (string) => {
    setError("");

    if (formData?.isView) {
      navigate('/')
      return
    }

    if (formData.step > 1) {

      dispatch(setStep(step - 1));

    }
  };

  const getProgress = () => {
    switch (step) {
      case 1:
        return 33;
      case 2:
        return 66;
      case 3:
        return 100;



      default:
        return 0;
    }
  };

  useEffect(() => {
    const stepToHeader = {
      // 1: "Company Information",
      // 1: "Basic Job Information ",
      1: "List Job Descriptors",
      2: "Behaviour Questions",

      // 4: "Skill and skill Groups",
      3: " Job Description",
    };

    dispatch(setHeaderText(stepToHeader[step] || ""));
  }, [step]);



  const handleKeywordChange = (e, keyword) => {
    // console.log("hiiiiiiiiiiiiiii", selectedKeywords)
    if (e.target.checked) {
      // setSelectedKeywords([...selectedKeywords, keyword]);
      dispatch(updateFormField({ field: 'selectedKeywords', value: [...formData.selectedKeywords, keyword] }));
    } else {
      // setSelectedKeywords(selectedKeywords.filter((kw) => kw !== keyword));
      const temp = formData.selectedKeywords.filter((kw) => kw !== keyword)
      dispatch(updateFormField({ field: 'selectedKeywords', value: temp }));
    }
  };

  const behaviourTraits = {
    A: "Accuracy",
    B: "Cooperativeness",
    C: "Efficiency",
    D: "Enthusiasm",
    E: "Friendliness",
    F: "Independence",
    G: "Patience",
    H: "Persistence",
    I: "Self Confidence",
    J: "Self Motivation",
    K: "Sensitivity",
    L: "Thoughtfulness"
  };


  // <--------------tab--------->


  function transformSkills(input) {
    if (!Array.isArray(input) || input?.length < 1) {
      return
      throw new TypeError("Expected an array as input");
      return
    }
    return input?.map(group => ({
      id: 0,
      groupName: group.group_name,
      skillsets: group.recommended_skills?.map(skill => ({
        id: 0,
        skillset: skill
      }))
    }));
  }
  function transformBehaviours(inputArray) {
    if (!Array.isArray(inputArray)) {
      throw new TypeError("Expected an array as input");
    }

    return inputArray?.map(item => ({
      id: 0,
      behaviourName: item.title || "",
      behaviourText1: item.reasonForSelection || "",
      behaviourText2: "" // Empty string as per requirement
    }));
  }
  function transformResponsibilities(input) {

    if (!input[0]?.responsibilites) return input
    return input?.map(group => ({
      id: 0,
      groupTitle: group.responsibilites_group,
      responsibilities: group.responsibilites.map(responsibility => ({
        id: 0,
        responsibilityText: responsibility
      }))
    }));
  }


  function normalizeToArray(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value.trim() !== "") return [value];
    return []; // handle undefined, null, empty string
  }


  async function pubLishJDAPI(isLoad = true) {

    setLoadingForPublishJD(isLoad);
    const transformSkillSet = transformSkills(formData.skillsRequiredForJob)
    const payload = {
      jobcode: formData.tempJobCode,
      company: {
        id: 0,
        companyName: formData.companyName,

        industry: formData.industry,
        companySize: formData.companySize,
        headQuarters: formData.location,
        companyType: formData.companyType,
        aboutCompany: formData.companyDescription,
        companyWebsite: formData.website,

      },
      jobInformation: {
        id: formData?.jobDescriptionId || 0,
        jobTitle: formData?.job_title || formData?.jobTitle,
        noOfPositions: formData.noOfPositions,
        department: formData.department,
        location: formData.finalJobDetails?.location,
        // languages: formData.finalJobDetails?.language,
        languages: normalizeToArray(formData.finalJobDetails?.language),
        jobType: formData.finalJobDetails?.job_type,
        workplaceType: formData.finalJobDetails?.workplace_type,
        descriptionAboutJob: formData.descriptionAboutJob,
        experienceReq: formData.finalJobDetails?.job_experience,
        salaryRange: formData.finalJobDetails?.salary,
        minimumEducationalQualification: formData.finalJobDetails?.job_qualifications,
        employmentType: formData.employmentType,
        // industry : formData.industry,
        industry: normalizeToArray(formData.industry),
        skillsets: formData.skillsRequiredForJob,
        educationAreas: [
          "Computer Science"
        ],
        role: formData?.job_title || formData?.jobTitle,
        requiredBy: "2025-06-10T00:00:00Z"
        // travel_requirements: formData.travelRequirement,
      },

      details: {
        id: formData?.detailsId,
        invitationToApply: formData.finalSelectedJobDescription,
        keyWords: formData.finalKeywordsForUser,
        responsibilities: "xyz",
        answers: formData?.answers,
        questions: formData.behaviourQuestionsArray,
        allKeywords: formData?.allKeywords,
        filtered_analysis: formData?.filteranalysis,
        allBehaviours: formData.behaviorsDataApi,

      },
      responsibilityGroups: transformResponsibilities(formData?.finalSelectedResponsibilities),

      quizzes: quizes?.length > 0 ? quizes : [],

      skillgroups: formData.generatedSkillsArray || [],
      step: 3,
      behaviours: transformBehaviours(formData.behaviorsDataApi?.selectedByUser),




    };

    try {
      const response = await fetchPOST(ApiConfig.POST_PUBLISH_JD, payload);

      if (response.response.status === true) {
        if (isLoad) {
          toastMsg("success", response.response.statusMessage);
        }
        setIsAbleToPublish(true)
      }

      if (response.response.status === false) {
        toastMsg("error", response.response.statusMessage);
      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setLoadingForPublishJD(false);
    }
  }

  async function generateTempJobCodeAPI(behaviour) {

    // setLoadingForBehaviourQuestions(true);


    const customQues = await PostCallWithErrorResponse(ApiConfig.GENERATE_CUSTOM_QUESTIONS, {
      "company_details": {
        "company_name": formData.companyName,
        "industry": formData.industry,
        "company_size": formData.companySize,
        "location": formData.location,
        "company_type": formData?.companyType,
        "company_description": formData.companyDescription,
        "company_website": formData.website
      },
      job_details: {
        "job_title": formData?.jobTitle,
        "no_of_positions": formData?.noOfPositions,
        "job_department": formData?.department,
        "job_location": formData?.location,
        "job_language": formData?.anyLanguageOtherThanEnglish,
        "job_type": formData?.jobType,
        "workplace_type": formData?.workPlaceType,
        "job_description": formData?.descriptionAboutJob,
        "experience_required": formData?.experience,
        "salary_range": formData?.salary,
        "job_qualifications": formData?.minEducationQualification,
        "travel_requirements": formData?.travelRequirement
      },
      behaviors: behaviour,
      selected_keywords: formData?.selectedKeywords,
      filtered_analysis: formData?.filteranalysis
    })


    let customQuest = customQues?.json?.custom_questions?.map((ques, index) => {
      return {
        "questionText": ques,
        "questionNumber": 0,
        "isActive": true
      }
    })



    const payload = {
      jobInfoId: formData?.jobDescriptionId,
      step: 2,
      code: formData?.tempJobCode,
      selectedBehaviours: behaviour,
      customQuestions: customQuest,
      answers: formData?.answers,
      questions: formData.behaviourQuestionsArray,


    };



    try {
      const response = await fetchPOST(
        ApiConfig.POST_TEMP_JOB_CODE,
        payload
      );

      if (response.response.status) {

        dispatch(updateFormField({ field: 'tempJobCode', value: response.response.jobcode }));
      }
    } catch (err) {
      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      // setLoadingForBehaviourQuestions(false);
    }
  }

  // const transformResponsibilities = (data) => {


  //   return data.map(group => ({

  //     groupTitle: group.responsibilites_group, // map group title
  //     responsibilities: group.responsibilites.map(item => ({

  //       responsibilityText: item // map responsibility text
  //     }))
  //   }));
  // };

  const downloadJd = (isPdf = true) => {


    let payload = {
      id: formData?.jobDescriptionId,
    }

    let api = isPdf ? ApiConfig.DOWNLOAO_JD : ApiConfig.DOWNLOAD_WORD_FILE

    PostCallWithErrorResponse(api, payload).then((res) => {


      let data = res?.json;

      let file = isPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

      FileSaver.saveAs(
        "data:" + file + ";base64," + data?.response,
        "Job Description"
      );

      setISDownloading(false)

      setIsDownloadingWord(false)

    })


  }



  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    documentTitle: 'Job_Description',
    contentRef: componentRef,
    pageStyle: `
      @page {
        size: A4;
        margin: 0;
      }
  
      @media print {
        body {
          font-family: Calibri, sans-serif;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          counter-reset: page;
        }
  
        .footer {
          display:"none",
          position: fixed;
          bottom: 10mm;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 10px;
          color: #666;
        }

          .print-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 10px 40px; /* 10px top/bottom and 40px left/right */
  /* border-bottom: 1px solid #000; */
  box-sizing: border-box; /* Ensures padding does not overflow */
}

.print-content {
  margin-top: 100px; /* Adjust this value based on header height */
  padding: 0 40px 20px; /* Matches the header's side padding for alignment */
  box-sizing: border-box;
}
  
        .page-number:after {
          content: "Page " counter(page);
        }
      }
    `
  });


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {

      const trimmedKeyword = customKeyword.trim();
      if (trimmedKeyword) {
        // If not already in the keyword list, add it
        if (!formData.allKeywords.includes(trimmedKeyword)) {
          // setAllKeywords((prev) => [...prev, trimmedKeyword]);
          dispatch(updateFormField({ field: 'allKeywords', value: [...formData.allKeywords, trimmedKeyword] }));
          setCustomKeywords((prev) => [...prev, trimmedKeyword]); // Track as custom
        }

        // If not already selected, select it
        if (!formData.selectedKeywords.includes(trimmedKeyword)) {
          // setSelectedKeywords((prev) => [
          //   ...prev,
          //   trimmedKeyword,
          // ]);
          dispatch(updateFormField({ field: 'selectedKeywords', value: [...formData.selectedKeywords, trimmedKeyword] }));
        }

        setCustomKeyword("");
      }
    }
  }

  const storeKeyword = () => {
    const stored = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);
    const prevKeywords = stored ? JSON?.parse(stored || '') : [];

    const hasChanged = !arraysAreEqual(formData?.selectedKeywords, prevKeywords);

    if (!hasChanged) return



    PostCallWithErrorResponse(ApiConfig.POST_TEMP_JOB_CODE, {
      jobInfoId: formData?.jobDescriptionId,
      keywords: formData?.selectedKeywords,
      step: 1,
      allKeywords: formData?.allKeywords,
      filtered_analysis: formData?.filteranalysis
    })
  }

  function transformBehaviouralJD(behaviouralJD) {
    const { selected, non_selected, justifications } = behaviouralJD;

    const mapSelectedByUser = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};
      console.log('111b--', justification)
      return {
        title: trait,
        behaviourCode: code,
        reasonForSelection: justification.reason,
        comparison: justification.compared_to || justification.comparison,
        conditionForReconsideration: justification.deprioritize_conditions,
      };
    };

    const mapSelected = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};

      return {
        title: trait,
        behaviourCode: code,
        reasonForSelection: justification.reason,
        comparison: justification.compared_to,
        conditionForReconsideration: justification.deprioritize_conditions,
      };
    };

    const mapNonSelected = (code) => {
      const trait = behaviourTraits[code];
      const justification = justifications[code] || {};

      return {
        title: trait,
        behaviourCode: code,
        reasonForNonSelection: justification.reason,
        comparison: justification.compared_to,
        conditionForReconsideration: justification.deprioritize_conditions,
        selfConfidence: justification.self_confidence,
      };
    };

    return {
      selectedByUser: selected.map(mapSelectedByUser),
      selected: selected.map(mapSelected),
      nonSelected: non_selected.map(mapNonSelected),
    };
  }
  useEffect(() => {
    if (formData?.identifiedBehaviour?.behavioural_jd && formData.behaviorsDataApi?.selected?.length < 1) {
      const modifedData = transformBehaviouralJD(formData?.identifiedBehaviour?.behavioural_jd)
      // setBehaviorsDataApi(modifedData)
      dispatch(updateFormField({ field: 'behaviorsDataApi', value: modifedData }))

    }
  }, [formData?.identifiedBehaviour])


  const resetKeyWord = () => {

    const stored2 = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);

    const prevKeywords = stored2 ? parseJSONSafe(stored2) : []

    dispatch(updateFormField({ field: 'selectedKeywords', value: prevKeywords }));

    setIsKeywordChange(false)

  }



  return (
    // <div className="jb-1 all-in ">
    <>
      <div
        style={{ backgroundColor: "#f7f9fc" }}
        className={`canLisContentWrap ${!openSideBar ? "fullwidth" : null}`}
      >
        <div
          // show={show}
          // centered
          // onHide={handleClose}
          // dialogClassName="custom-modal"
          // size={`${details.reason === "Job Application" ? "xl" : "lg"}`}
          className="t-wrapper-div"
          style={{ padding: "10px" }}
        >
          <main className="flex-1 p-10 bg-white" style={{ padding: '20px' }}>
            {console.log("step-->", step)}
            {
              !formData?.isView &&

              <div className="progress" style={{ height: "0.5rem" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${getProgress()}%`,
                    background: "#444ce7",
                  }}
                  aria-valuenow={getProgress()}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            }
            <div className="custom-close-btn mt-1">
              <div className="canLisTxtStyl mb-1-">
                <p>{headerText}</p>
              </div>
            </div>

            <hr />

            <div className="border-t border-gray-200 mb-6" />


            {step === 1 && (
              <>
                {/* <h3 className="j3 mt-4">Keyword Selection</h3> */}
                <div className="space-y-5 max-w-4xl job-description-form">
                  <div className="">
                    <div className="-flex justify-between margin-btn-input">
                      <div className="canLisTxtStyl mb-2" style={{ marginTop: '-5px' }}>
                        <p className="font-color-text" >Custom Descriptors</p>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        {loadingForGenerateKeyword ? <InputSkeleton width={'30%'} /> : (
                          <input
                            name="customKeyword"
                            placeholder=" Enter Custom Keyword Here"
                            value={customKeyword}
                            onChange={(e) => setCustomKeyword(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="w-full p-2 rounded-md bg-green-500 border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1"
                            style={{ width: "30%", height: "37px" }}
                          />
                        )}
                        <CustomButton
                          title="Add"
                          isLoading={false}
                          type='button'
                          handleClick={() => {
                            const trimmedKeyword = customKeyword.trim();
                            if (trimmedKeyword) {
                              // If not already in the keyword list, add it
                              if (!formData.allKeywords.some(
                                (keyword) => keyword.toLowerCase() === trimmedKeyword.toLowerCase()
                              )) {
                                // setAllKeywords((prev) => [...prev, trimmedKeyword]);
                                dispatch(updateFormField({ field: 'allKeywords', value: [trimmedKeyword, ...formData.allKeywords] }));
                                // setCustomKeywords((prev) => [...prev, trimmedKeyword]); // Track as custom
                                setCustomKeywords((prev) => [trimmedKeyword, ...prev]);
                              } else {
                                toastMsg('error', 'Keyword Already Exist!')
                                return
                              }

                              // If not already selected, select it
                              if (!formData.selectedKeywords.includes(trimmedKeyword)) {
                                // setSelectedKeywords((prev) => [
                                //   ...prev,
                                //   trimmedKeyword,
                                // ]);
                                dispatch(updateFormField({ field: 'selectedKeywords', value: [trimmedKeyword, ...formData.selectedKeywords] }));
                              } else {
                                toastMsg('error', 'Keyword Already Exist!')
                              }

                              setCustomKeyword("");
                            } else {
                              toastMsg('error', 'Please Enter Keword To Add')
                            }
                          }}
                          buttonType='tertiory'
                        />

                      </div>
                      {/* Show selected keywords in one row */}



                      {/* Show selected keywords in one row */}
                    </div>
                    <div className="">
                      <p className="subTitleClr" style={{ fontWeight: '500' }}>
                        Select Job Descriptors ( Select as many as needed, Recommended ones are already selected for you)
                      </p>
                    </div>
                    <div className="col-md-12 " style={{ marginTop: '-10px' }}>
                      {loadingForGenerateKeyword ? (<KeywordSkeleton count={20} />) : (
                        <div className="row">
                          {formData.allKeywords.map((keyword, index) => (
                            <div className="col-md-4">
                              <div
                                key={index}
                                className="flex items-center j5"
                                style={{ display: "flex", gap: "5px" }}
                              >
                                <input
                                  type="checkbox"
                                  id={`keyword-${index}`}
                                  checked={formData?.selectedKeywords?.includes(keyword)}
                                  onChange={(e) => handleKeywordChange(e, keyword)}
                                  // className="mr-2 custom-checkbox"
                                  className={`mr-2 ${customKeywords.includes(keyword) ? "custom-checkbox--2" : "custom-checkbox"}`}
                                />

                                <label
                                  // className="job_size"
                                  // htmlFor={`keywo-- form-labelrd-${index}`}
                                  className={`job_size ${customKeywords.includes(keyword) ? "job_size--v2" : ""}`}
                                  htmlFor={`keyword-${index}`}
                                >
                                  {keyword}
                                </label>
                              </div>
                            </div>
                          ))}{" "}
                        </div>
                      )}
                    </div>

                    <div
                      className="d-flex  mt-4 gap-2"
                      style={{
                        width: "100%",
                        justifyContent: "flex-end",

                      }}
                    >
                      <CustomButton
                        isLoading={false}
                        title={"Back"}
                        handleClick={() => {

                          if (!loadingForGenerateKeyword) {
                            sessionStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(company_details));
                            sessionStorage.setItem(JOBDETAILS_STORAGE_KEY, JSON.stringify(job_details));
                          }




                          navigate('/?isBack=' + true)
                        }
                        }
                        buttonType={'secondary'}
                      />
                      <CustomButton
                        isLoading={false}
                        title={"Proceed"}
                        handleClick={() => {


                          if (formData?.selectedKeywords?.length == 0) {
                            toastMsg('error', 'Please Select At least 1 Discriptor')
                            return
                          }

                          if (regenrateJd) {

                            const stored2 = sessionStorage.getItem(KEYWORDS_STORAGE_KEY);

                            const prevKeywords = stored2 ? parseJSONSafe(stored2) : [];

                            if (!arraysAreEqual(prevKeywords, formData?.selectedKeywords)) {
                              setIsKeywordChange(true)
                              return
                            }





                          }

                          storeKeyword()
                          dispatch(setStep(3))
                          functionToTriggerBehaviourGeneration()
                        }}
                      />

                    </div>
                  </div>
                </div>
                {error && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      className="bg-red-100 text-red-700 p-3 rounded mt-4 jb-sub"
                      style={{ width: "100%" }}
                    >
                      {error}
                    </div>
                  </div>
                )}
              </>
            )}

            {step === 2 && (
              <>

                {/* <h3 className="j3 mt-4">Behaviour Questions</h3> */}
                <form className="space-y-5 max-w-4xl job-description-form">

                  <>
                    <BehaviourQuestions
                      loadingForBehaviourQuestions={loadingForBehaviourQuestions}
                      result={result}
                      handleOptionChange={handleOptionChange}
                    />

                    {/* <pre className="bg-gray-100 p-4 mt-6 rounded-md text-sm">
                Selected Answers: {JSON.stringify(formData.answers, null, 2)}
              </pre> */}


                  </>

                  {error && (
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <div
                        className="bg-red-100 text-red-700 p-3 rounded mt-4 jb-sub"
                        style={{ width: "100%" }}
                      >
                        {error}
                      </div>
                    </div>
                  )}


                  <div
                    className="d-flex  mt-4 gap-2"
                    style={{
                      width: "100%",
                      justifyContent: "flex-end",

                    }}
                  >
                    <CustomButton
                      isLoading={false}
                      title="Back"
                      handleClick={prevStep}
                      buttonType={'secondary'}
                    />
                    <CustomButton
                      // isLoading={loadingForGettingBehaviour}
                      title="Proceed"
                      handleClick={functionToTriggerBehaviourGeneration}
                    // isDisabled={loadingForGettingBehaviour || loadingForBehaviourQuestions}
                    />

                    {/* )} */}
                  </div>
                </form>
              </>
            )}

            {/* {step === 4 && (
              <>
              
                <form className="space-y-5 max-w-4xl job-description-form">
                  <Behaviors />

                  <div
                    className="d-flex  mt-4 gap-2"
                    style={{
                      width: "100%",
                      justifyContent: "flex-end",

                    }}
                  >
                    <CustomButton
                      isLoading={false}
                      title="Back"
                      handleClick={prevStep}
                      buttonType={'secondary'}
                    />
                    <CustomButton
                      isLoading={loadingForGenerateSkills}
                      title="Proceed"
                      handleClick={nextStep}
                    />
                  </div>
                </form>
                {error && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      className="bg-red-100 text-red-700 p-3 rounded mt-4 jb-sub"
                      style={{ width: "100%" }}
                    >
                      {error}
                    </div>
                  </div>
                )}
              </>
            )} */}

            {/* {step === 4 && (
              <>
             
                <form className="space-y-5 max-w-4xl job-description-form">
            
                  <GeneratedSkills  />

                  <div
                    className="d-flex  mt-4 gap-2"
                    style={{
                      width: "100%",
                      justifyContent: "flex-end",

                    }}
                  >
                    <CustomButton
                      isLoading={false}
                      title="Back"
                      handleClick={prevStep}
                      buttonType={'secondary'}
                    />
                    <CustomButton
                      isLoading={false}
                      title="Primary Responsibilities"
                      handleClick={nextStep}
                    />
                  </div>
                </form>
                {error && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      className="bg-red-100 text-red-700 p-3 rounded mt-4 jb-sub"
                      style={{ width: "100%" }}
                    >
                      {error}
                    </div>
                  </div>
                )}
              </>
            )} */}
            {step === 3 && (
              <>
                {/* <PDFExport ref={pdfExportComponent} paperSize="auto" margin={40} fileName={`Report for ${new Date().getFullYear()}`} author="KendoReact Team"> */}
                <div className="content-tabs-container" >


                  <TotalMarketing loadingForRegenerateSkills={loadingForRegenerateSkills} regenerateSkillsAPI={regenerateSkillsAPI} loadingForGettingBehaviour={loadingForGettingBehaviour} loadingForGenerateSkills={loadingForGenerateSkills} componentRef={componentRef} setQuizes={setQuizes} quizes={quizes} loadingForPublishJD={loadingForPublishJD} pubLishJDAPI={pubLishJDAPI} loadingForGeneratedCustomQuestions={loadingForGeneratedCustomQuestions} regenerateJobDetailsAPI={regenerateJobDetailsAPI} loadingForRegeneratedJobDetails={loadingForRegeneratedJobDetails} loadingForRegeneratedKeywords={loadingForRegeneratedKeywords} regenerateKeywordsForUserAPI={regenerateKeywordsForUserAPI} loadingForGenerateKeyword={loadingForGenerateKeyword} loadingForRegenerateJobResponsibilities={loadingForRegenerateJobResponsibilities} generateJobResponsibilitiesAPI={generateJobResponsibilitiesAPI} loadingForRegenerateJobDescription={loadingForRegenerateJobDescription} generateJobDescriptionAPI={generateJobDescriptionAPI} loadingForGenerateJobDescription={loadingForGenerateJobDescription} />
                  <div style={{ display: 'none' }}>
                    <JobDatas componentRef={componentRef} />
                  </div>
                </div>
                {/* </PDFExport> */}
                <div
                  className="d-flex mt-4 gap-2"
                  style={{
                    width: "100%",
                    justifyContent: "flex-end",
                    position: 'sticky',
                    bottom: '5%',


                  }}
                >
                  <CustomButton
                    isLoading={false}
                    title="Back"
                    handleClick={() => {
                      // prevStep() 




                      if (formData?.isView) {
                        navigate('/')
                        return
                      }

                      setIsReenerateJd(true)

                      dispatch(setStep(1))
                    }}
                    buttonType={'secondary'}
                  />

                  {/* <CustomButton
                    isLoading={isDownloading}
                    title="Download"
                    handleClick={async () => {
                      setISDownloading(true)
                      if (!formData?.isView) {
                        let res = await pubLishJDAPI(false)
                      }
                      downloadJd()
                      // handlePrintBack
                    }}
                    buttonType={'secondary'}
                  /> */}

                  <CustomButton
                    isLoading={isDownloadingWord}
                    title="Download"
                    handleClick={async () => {
                      setIsDownloadingWord(true)
                      if (!formData?.isView) {
                        let res = await pubLishJDAPI(false)
                      }
                      downloadJd(false)
                      // handlePrint
                    }}
                    buttonType={'secondary'}
                  />
                  {
                    !formData?.isView && <>
                      {
                        adminData?.admin == 'Admin' &&

                        <CustomButton
                          title={'Pubilsh'}
                          handleClick={() => {
                            if (isAbleToPublish) {
                              navigate("/addEditGroup/" + formData?.tempJobCode + `?detailsId=${formData?.tempJobCodeResp?.jdJobInformationId}`)

                            } else {
                              toastMsg('error', 'Please Save Data First !')
                            }
                          }}
                          buttonType={'secondary'}
                        />
                      }
                      <div style={{ marginRight: '16px' }}>
                        <CustomButton
                          title={'Save'}
                          isDisabled={loadingForPublishJD || loadingForGenerateJobDescription}
                          isLoading={loadingForPublishJD}
                          handleClick={pubLishJDAPI}
                        // icon={send}
                        />
                      </div>
                    </>
                  }

                </div>
              </>
            )}
          </main>
        </div>
      </div >

      <MessageBox
        isOpen={isKeyWordChange}
        closeOnOutClick={false}
      >
        <div className="text-center interRegular p-2">
          You have made changes , this will over write your earlier work , do you want to apply these changes
        </div>
        <div className="d-flex gap-2 justify-content-center mt-2">
          <CustomButton title="No" buttonType="secondary" handleClick={resetKeyWord} />
          <CustomButton title="Yes" handleClick={() => {
            setIsKeywordChange(false)
            storeKeyword()
            dispatch(setStep(3))
            functionToTriggerBehaviourGeneration()

          }} />
        </div>
      </MessageBox>
    </>
  );
}
